module.exports = __webpack_public_path__ + "img/img18.850b033.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img18.jpg
// module id = 283
// module chunks = 0